/* Information page: in-page nav highlighting, smooth anchor scrolling (also for the header dropdown), image lightbox. */
(function () {
  var root = document.querySelector('[data-exp-info]'); if (!root) return;

  // ---- smooth scroll for same-page anchors (header dropdown + TOC) ----
  function scrollTo(id, push) {
    var el = document.getElementById(id); if (!el) return false;
    el.scrollIntoView({ behavior: 'smooth', block: 'start' });
    if (push) history.pushState(null, '', '#' + id);
    return true;
  }
  document.addEventListener('click', function (e) {
    var a = e.target.closest('a[href*="#"]'); if (!a) return;
    var url = new URL(a.href, location.href);
    if (url.pathname !== location.pathname || !url.hash) return;
    if (scrollTo(url.hash.slice(1), true)) e.preventDefault();
  });
  if (location.hash) setTimeout(function () { var el = document.getElementById(location.hash.slice(1)); if (el) el.scrollIntoView({ block: 'start' }); }, 60);

  // ---- TOC highlight ----
  var links = {};
  root.querySelectorAll('[data-toc]').forEach(function (a) { links[a.getAttribute('data-toc')] = a; });
  var sections = Array.prototype.slice.call(root.querySelectorAll('[data-section]'));
  var tocList = root.querySelector('.exp-info__toc ol');
  // desktop: the list scrolls inside the pinned panel (CSS), so fade whichever edge has more topics past it
  function tocFades() {
    if (!tocList) return;
    var more = tocList.scrollHeight - tocList.clientHeight > 2;
    tocList.style.setProperty('--fade-top', more && tocList.scrollTop > 2 ? '28px' : '0px');
    tocList.style.setProperty('--fade-bottom', more && tocList.scrollTop + tocList.clientHeight < tocList.scrollHeight - 2 ? '28px' : '0px');
  }
  // ...and keep the highlighted topic in view as the page moves on, without moving the page itself
  function revealInToc(a) {
    if (!tocList || tocList.scrollHeight - tocList.clientHeight <= 2) return;
    var r = a.getBoundingClientRect(), o = tocList.getBoundingClientRect();
    if (r.top >= o.top + 28 && r.bottom <= o.bottom - 28) return;
    tocList.scrollTo({ top: tocList.scrollTop + (r.top - o.top) - (o.height - r.height) / 2, behavior: 'smooth' });
  }
  if (tocList) {
    tocList.addEventListener('scroll', tocFades, { passive: true });
    window.addEventListener('resize', tocFades);
    tocFades();
  }
  function setActive(id) {
    Object.keys(links).forEach(function (k) { if (k === id) links[k].setAttribute('aria-current', 'true'); else links[k].removeAttribute('aria-current'); });
    if (links[id]) revealInToc(links[id]);
  }
  if ('IntersectionObserver' in window) {
    var visible = {};
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { visible[en.target.id] = en.isIntersecting ? en.boundingClientRect.top : null; });
      var best = null, bestTop = Infinity;
      sections.forEach(function (s) { var t = visible[s.id]; if (t != null && Math.abs(t) < bestTop) { bestTop = Math.abs(t); best = s.id; } });
      if (best) setActive(best);
    }, { rootMargin: '-20% 0px -60% 0px', threshold: [0, 0.2, 0.5] });
    sections.forEach(function (s) { io.observe(s); });
  }

  // ---- picture columns travel with the copy (desktop) ----
  // Where a section's copy runs longer than its pictures, the picture column is sticky (CSS), so it stays
  // beside the text being read. A column taller than the window is pinned by its foot rather than its
  // head, so its last picture is still reached before the section ends.
  (function stickyPictures() {
    var cols = Array.prototype.slice.call(root.querySelectorAll('[data-gal]'));
    if (!cols.length) return;
    var wide = window.matchMedia('(min-width: 1024px)');
    function update() {
      cols.forEach(function (c) {
        if (!wide.matches) { c.style.removeProperty('--gal-top'); return; }
        c.style.setProperty('--gal-top', Math.min(24, window.innerHeight - c.offsetHeight - 24) + 'px');
      });
    }
    window.addEventListener('resize', update);
    window.addEventListener('load', update);
    wide.addEventListener ? wide.addEventListener('change', update) : wide.addListener(update);
    update();
  })();

  // ---- looping videos (Installation's "Watch It Expand") ----
  // No control bar: the video plays muted on a loop while it is on screen and pauses off screen, so it only
  // loads once someone scrolls to it. A click pauses or resumes it. With reduced motion asked for, it stays
  // on its poster until clicked.
  (function loopVideos() {
    var vids = Array.prototype.slice.call(root.querySelectorAll('[data-loop-video]'));
    if (!vids.length) return;
    var still = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    vids.forEach(function (v) {
      v.muted = true;
      v.addEventListener('click', function () { v.dataset.held = v.paused ? '' : '1'; if (v.paused) v.play().catch(function () {}); else v.pause(); });
    });
    function run(v, on) {
      if (on && !still && !v.dataset.held) { if (v.paused) v.play().catch(function () {}); }
      else if (!on && !v.paused) v.pause();
    }
    if (!('IntersectionObserver' in window)) { vids.forEach(function (v) { run(v, true); }); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { run(en.target, en.isIntersecting); });
    }, { rootMargin: '200px 0px' });
    vids.forEach(function (v) { io.observe(v); });
  })();

  // ---- lightbox for every figure on the page (per-section image set, arrows move within the section) ----
  var lb = root.querySelector('[data-fp-lightbox]'); if (!lb) return;
  var img = lb.querySelector('img'), title = lb.querySelector('[data-fp-title]'), sub = lb.querySelector('[data-fp-sub]'), count = lb.querySelector('[data-fp-count]');
  var set = [], cur = 0;
  function full(src) { return src.replace(/_\d+x(\.[a-z0-9]+)$/i, '$1'); }
  function show(i) {
    if (!set.length) return;
    cur = (i + set.length) % set.length; var f = set[cur];
    img.src = full(f.img.getAttribute('src')); img.alt = f.img.alt;
    title.textContent = f.caption || f.img.alt || ''; sub.textContent = f.sectionTitle; count.textContent = (cur + 1) + ' / ' + set.length;
  }
  function open(list, i) { set = list; show(i); lb.setAttribute('open', ''); document.documentElement.style.overflow = 'hidden'; lb.querySelector('.exp-lightbox__close').focus(); }
  function close() { lb.removeAttribute('open'); document.documentElement.style.overflow = ''; }
  lb.querySelector('.exp-lightbox__close').addEventListener('click', close);
  lb.querySelector('.exp-lightbox__prev').addEventListener('click', function () { show(cur - 1); });
  lb.querySelector('.exp-lightbox__next').addEventListener('click', function () { show(cur + 1); });
  lb.addEventListener('click', function (e) { if (e.target === lb || e.target.classList.contains('exp-lightbox__stage')) close(); });
  document.addEventListener('keydown', function (e) { if (!lb.hasAttribute('open')) return; if (e.key === 'Escape') close(); if (e.key === 'ArrowLeft') show(cur - 1); if (e.key === 'ArrowRight') show(cur + 1); });
  var tx = null; lb.addEventListener('touchstart', function (e) { tx = e.touches[0].clientX; }, { passive: true });
  lb.addEventListener('touchend', function (e) { if (tx == null) return; var dx = e.changedTouches[0].clientX - tx; if (Math.abs(dx) > 40) show(cur + (dx < 0 ? 1 : -1)); tx = null; });
  sections.forEach(function (s) {
    var h = s.querySelector('.exp-info__h2'); var sectionTitle = h ? h.textContent : '';
    // the brochure pages' pictures open too, so the foundation plans and colour charts can be read full size
    var figs = Array.prototype.slice.call(s.querySelectorAll('.exp-info__fig, .exp-split__fig'))
      .map(function (f) { var c = f.querySelector('figcaption'); return { img: f.querySelector('img'), caption: c ? c.textContent.trim() : '', sectionTitle: sectionTitle }; })
      .filter(function (f) { return f.img; });
    figs.forEach(function (f, i) { f.img.style.cursor = 'zoom-in'; f.img.addEventListener('click', function () { open(figs, i); }); });
  });

  // ---- back to contents (phone and tablet) ------------------------------------------------------
  // The page is long and the contents list only sits at the top on small screens, so a floating button
  // appears once you have scrolled past it and takes you straight back (Ollie, 17 Sep 2026).
  (function backToContents() {
    var btn = document.querySelector('[data-info-totop]');
    var toc = document.getElementById('exp-info-contents');
    if (!btn || !toc) return;
    var small = window.matchMedia('(max-width: 1023px)');
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
    function update() {
      var past = small.matches && (toc.getBoundingClientRect().bottom < -40);
      if (past === !btn.hidden) return;
      btn.hidden = !past;
    }
    btn.addEventListener('click', function () {
      var top = toc.getBoundingClientRect().top + window.scrollY - 12;
      window.scrollTo({ top: Math.max(0, top), behavior: reduce.matches ? 'auto' : 'smooth' });
      setTimeout(function () { var a = toc.querySelector('a'); if (a) a.focus({ preventScroll: true }); }, reduce.matches ? 0 : 500);
    });
    var ticking = false;
    window.addEventListener('scroll', function () {
      if (ticking) return; ticking = true;
      requestAnimationFrame(function () { update(); ticking = false; });
    }, { passive: true });
    small.addEventListener ? small.addEventListener('change', update) : small.addListener(update);
    update();
  })();
})();
